module.exports = __webpack_public_path__ + "img/snap.f05fc34b.jpg";